import React from "react";

import AdminAvatar from "../avatar/AdminAvatar";

import type { JSX } from "react";

export default function MenuUser({
  isCollapsed,
  collapsedSidebarClassNames,
}: {
  isCollapsed: boolean;
  collapsedSidebarClassNames: (isCollapsed?: boolean) => string;
}): JSX.Element {
  return (
    <div className="text-muted-foreground flex flex-col pt-[0.78125rem] pb-[0.3125rem] text-[0.78125rem]">
      <AdminAvatar
        withDetails
        withLogout
        collapsedSidebarClassNames={collapsedSidebarClassNames}
        isCollapsed={isCollapsed}
      />
    </div>
  );
}
